export default "__VITE_ASSET__1c282bab__"